import styled from "styled-components";

export const H1 = styled.h1`
  font-weight: 800;
  font-size: clamp(2.5rem, 5vw, 3.75rem);
  line-height: 1.1;
  letter-spacing: -0.02em;
  margin: 0;
`

export const H2 = styled.h2`
  font-weight: 700;
  font-size: clamp(1.75rem, 3.5vw, 2.5rem);
  line-height: 1.15;
  letter-spacing: -0.01em;
  margin: 0;
`

export const H3 = styled.h3`
  font-weight: 700;
  font-size: clamp(1.375rem, 2.5vw, 1.875rem);
  line-height: 1.2;
  letter-spacing: -0.01em;
  margin: 0;
`

export const BodyIntro = styled.p`
  font-weight: 500;
  font-size: clamp(1.125rem, 2vw, 1.5rem);
  line-height: 1.5;
  margin: 0;
`

export const BodyMain = styled.p`
  font-weight: 400;
  font-size: 1.25rem;
  line-height: 1.6;
  margin: 0;
`

export const MediumText = styled.p`
  font-weight: 400;
  font-size: 1.0625rem;
  line-height: 1.6;
  margin: 0;
`

export const Caption = styled.p`
  font-weight: 500;
  font-size: 0.9375rem;
  line-height: 1.4;
  margin: 0;
`

export const Caption2 = styled.p`
  font-weight: 600;
  font-size: 0.9375rem;
  line-height: 1.4;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin: 0;
`

export const SmallText = styled.p`
  font-weight: 400;
  font-size: 0.8125rem;
  line-height: 1.4;
  margin: 0;
`

export const SmallText2 = styled.p`
  font-weight: 600;
  font-size: 0.8125rem;
  line-height: 1.4;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  margin: 0;
`
